import { Clock, Context, Effect, Layer } from 'effect'

export class LocalTimeZone extends Context.Service<LocalTimeZone, string>()('LocalTimeZone') {}

export const localTimeZoneLiveLayer = Layer.effect(
  LocalTimeZone,
  Effect.sync(() => Intl.DateTimeFormat().resolvedOptions().timeZone)
)

export const currentLocalISODate = Effect.gen(function* () {
  const timeZone = yield* LocalTimeZone
  const milliseconds = yield* Clock.currentTimeMillis
  const parts = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone
  }).formatToParts(new Date(milliseconds))
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((candidate) => candidate.type == type)?.value
  const year = part('year')
  const month = part('month')
  const day = part('day')
  if (!year || !month || !day) {
    throw new Error(`Unable to format local date in ${timeZone}`)
  }
  return `${year}-${month}-${day}`
})
